<div class="inner-content">
  <div class="flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="title-icon" icon="assets/icon/red-alert.svg"></ion-icon>
      <span class="title barlow">¡ATENCIÓN!</span>
    </div>
    <ion-icon
      class="close-icon cursor-pointer"
      icon="assets/icon/cross.svg"
      (click)="modalController.dismiss()"
    ></ion-icon>
  </div>
  <hr />
  <div class="content-section">
    <ion-label class="label barlow">
      Vas a eliminar la siguiente carpeta: <strong>{{ group.product.folderName }}</strong>
    </ion-label>
    <app-print-group-folder-item
      [isStatic]="true"
      [currentPrintProduct]="currentPrintProduct"
      [group]="group"
    ></app-print-group-folder-item>
  </div>
  <span class="annotation">No podrás deshacer esta acción.</span>
  <hr />
  <div class="w-100 flex flex-row justify-end gap-2.5">
    <ion-button color="medium-light" (click)="cancel()">Cancelar</ion-button>
    <ion-button class="flex-1" color="danger" (click)="submit()">
      <ion-icon src="assets/icon/eliminar.svg" class="mr-2.5"></ion-icon>
      Eliminar ahora
    </ion-button>
  </div>
</div>
